<template>
  <span ref="text" v-html="purpose.html"></span>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "PrimaryPurpose",

  props: {
    purpose: {
      type: Object,
      required: true,
    },
  },

  methods: {
    purposeChanged(value: boolean): void {
      const textElement = this.$refs.text as HTMLElement;

      this.$emit("purposeChanged", {
        form_purpose_id: this.purpose.id,
        text: textElement.innerHTML,
        checked: value,
      });
    },
  },

  mounted(): void {
    const element = this.$refs.text as HTMLElement;

    element.querySelectorAll("a").forEach((item) => {
      item.classList.add("f-text-blue-500");
      item.classList.add("hover:f-underline");
    });

    this.purposeChanged(true);
  },
});
</script>

<style></style>
